import React from "react";

export default function MySQL_LEFT() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_LEFT</h1>
      <p>This is the MySQL_LEFT component generated from the SQL JSON.</p>
    </div>
  );
}
